import React, { useEffect, useState } from "react";
import axios from "axios";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { apiUrl, assetsUrl } from "../config/Config";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import userplaceholder from '../assets/images/userplaceholder.png';
import { faCoins, faEye, faDownload
   } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import ProgressBar from "@ramonak/react-progress-bar";
  import { useDispatch, useSelector } from 'react-redux';

  import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import formatCreatedDateWithSuffix from "../Helpers/formatCreatedDateWithSuffix";

const UserProfile = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch(); 
  const inkcustomerdata = useSelector((store) => store.userReducer.inkcustomerdata);
  // console.log('UserProfile inkcustomerdata >>', inkcustomerdata);
  const [activesection, setactivesection] = useState("Updateprofile");
  const [fullname, setfullname] = useState("");
    const [emailaddress, setemailaddress] = useState("");
    const [phonenumber, setphonenumber] = useState("");
    const [password, setpassword] = useState("");
    const [repassword, setrepassword] = useState("");
  
    const [fullnameerrormessage, setfullnameerrormessage] = useState("");
    const [emailaddresserrormessage, setemailaddresserrormessage] = useState("");
    const [phonenumbererrormessage, setphonenumbererrormessage] = useState("");
    const [passworderrormessage, setpassworderrormessage] = useState("");
    const [repassworderrormessage, setrepassworderrormessage] = useState("");
    const [mismatchpassworderrormessage, setmismatchpassworderrormessage] =
      useState("");
  
    const [showloading, setshowloading] = useState(false);

    const [currentcredits, setcurrentcredits] = useState(0);
    const [currentplan, setcurrentplan] = useState("");
    const [lastpurchased, setlastpurchased] = useState("");

    const [remainingpercentage, setremainingpercentage] = useState(0);

    const [bilingdata, setbilingdata] = useState([]);
    const [spendhistorydata, setspendhistorydata] = useState([]);

    const isValidEmail = (email) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    };
  
    const isValidPhoneNumber = (phone) => {
      const regex = /^\+[1-9]\d{7,14}$/;
      return regex.test(phone);
    };
  
    const handlesignupfunc = async () => {
      var isfullnameerror = false;
      var isemailaddresserror = false;
      var isphonenumbererror = false;
      var ispassworderror = false;
      var isrepassworderror = false;
      var ismismatchpassworderror = false;
  
      if (fullname) {
        isfullnameerror = false;
        setfullnameerrormessage("");
      } else {
        isfullnameerror = true;
        setfullnameerrormessage("Full Name cannot be empty.");
      }
  
      if (emailaddress && isValidEmail(emailaddress)) {
        isemailaddresserror = false;
        setemailaddresserrormessage("");
      } else {
        isemailaddresserror = true;
        if (emailaddress) {
          setemailaddresserrormessage("Invalid Email Address.");
        } else {
          setemailaddresserrormessage("Email Address cannot be empty.");
        }
      }
  
      if (phonenumber && isValidPhoneNumber(phonenumber)) {
        isphonenumbererror = false;
        setphonenumbererrormessage("");
      } else {
        isphonenumbererror = true;
        setphonenumbererrormessage("Invalid Mobile Number.");
      }
  
      // if (password) {
      //   ispassworderror = false;
      //   setpassworderrormessage("");
      // } else {
      //   ispassworderror = true;
      //   setpassworderrormessage("Enter Password.");
      // }
  
      // if (repassword) {
      //   isrepassworderror = false;
      //   setrepassworderrormessage("");
      // } else {
      //   isrepassworderror = true;
      //   setrepassworderrormessage("Enter Re-Password.");
      // }
  
      if (
        !isfullnameerror &&
        !isemailaddresserror &&
        !isphonenumbererror &&
        !ispassworderror &&
        !isrepassworderror &&
        !ismismatchpassworderror
      ) {
        if (password == repassword) {
          console.log("validation passed!!");
          ismismatchpassworderror = false;
          setmismatchpassworderrormessage("");
        } else {
          ismismatchpassworderror = true;
          setmismatchpassworderrormessage(
            "Password & Re-password does not match!!"
          );
          return;
        }
      } else {
        console.log("validation failed!!");
        // alert("validation failed!!");
        return;
      }
      setshowloading(true);
      var data = {
        fullname: fullname,
        emailaddress: emailaddress,
        mobilenumber: phonenumber,
        password: password,
        via: "form",
      };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + inkcustomerdata?.token,
        },
      };
  
      try {
        const res = await axios.post(apiUrl + "profileupdate", data, headers);
        if (res.data.status === "success") {
          setshowloading(false);
          dispatch({ type: "inkcustomerdata", payload: res.data.data })
          toast.error("Updated Successfully!!");
          setpassword("");
          setrepassword("");
          navigate('/user-profile');
          
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "inkcustomerdata", payload: {} })
            navigate('/login');
          } else {
            toast.error(res.data.message || "Registration Failed.");
            setshowloading(false);
          }
          
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Network or Server Error!");
        setshowloading(false);
      }
      setshowloading(false);
    };

    const handleuserlogout = async() => {
      var data = {
        emailaddress: emailaddress,
      };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + inkcustomerdata?.token,
        },
      };
      try {
        const res = await axios.post(apiUrl + "user-logout", data, headers);
        if (res.data.status === "success") {
          setshowloading(false);
          dispatch({ type: "inkcustomerdata", payload: {} })
          toast.success("Logged Out Successfully!!");
          navigate('/login');
          
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "inkcustomerdata", payload: {} })
            navigate('/login')
          } else {
            toast.error(res.data.message);
            setshowloading(false);
          }
          
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Network or Server Error!");
        setshowloading(false);
      }
      // navigate('/login')
    }

    const fetchallbilinghistory = async() => {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + inkcustomerdata?.token,
        },
      };
      try {
        const res = await axios.get(apiUrl + "user-getbillinghistory", headers);
        if (res.data.status === "success") {
          setbilingdata(res?.data?.data);
          // setshowloading(false);
          // dispatch({ type: "inkcustomerdata", payload: {} })
          // toast.error("Logged Out Successfully!!");
          // navigate('/login');
          
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "inkcustomerdata", payload: {} })
            navigate('/login')
          } else {
            toast.error(res.data.message);
            setshowloading(false);
          }
          
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Network or Server Error!");
        setshowloading(false);
      }
    }

    const fetchspendhostory = async() => {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + inkcustomerdata?.token,
        },
      };
      try {
        const res = await axios.get(apiUrl + "user-getspendhistory", headers);
        if (res.data.status === "success") {
          setspendhistorydata(res?.data?.data);
          
        } else {
          if(res.data.message == "invalid user") {
            dispatch({ type: "inkcustomerdata", payload: {} })
            navigate('/login')
          } else {
            toast.error(res.data.message);
            setshowloading(false);
          }
          
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Network or Server Error!");
        setshowloading(false);
      }
    }

    // const getRemainingDays = (purchaseDateStr, type = "monthly") => {
    //   if (!purchaseDateStr) return 0;
    
    //   const purchaseDate = new Date(purchaseDateStr);
    //   const expiryDate = new Date(purchaseDate);
    
    //   // Apply plan logic
    //   if (type === "monthly") {
    //     expiryDate.setMonth(expiryDate.getMonth() + 1);
    //   } else if (type === "yearly") {
    //     expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    //   }
    
    //   expiryDate.setDate(expiryDate.getDate() - 1); // inclusive logic
    
    //   const now = new Date();
    
    //   // Difference in ms → convert to days
    //   const diff = expiryDate.getTime() - now.getTime();
    
    //   const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    
    //   return days > 0 ? days : 0;
    // };

    const getRemainingDays = (
      purchaseDateStr,
      numberOfDays
    ) => {
      if (!purchaseDateStr) return 0;
    
      const purchaseDate = new Date(purchaseDateStr);
    
      // expiry = purchase date + number of days
      const expiryDate = new Date(purchaseDate);
      expiryDate.setDate(expiryDate.getDate() + numberOfDays);
    
      const now = new Date();
    
      // Difference in ms → convert to days
      const diff = expiryDate.getTime() - now.getTime();
    
      const days = Math.ceil(
        diff / (1000 * 60 * 60 * 24)
      );
    
      return days > 0 ? days : 0;
    };

    const getYearlyProgress = (purchaseDateStr) => {
      const purchaseDate = new Date(purchaseDateStr);
    
      // expiry = +1 year -1 day
      const expiryDate = new Date(purchaseDate);
      expiryDate.setFullYear(expiryDate.getFullYear() + 1);
      expiryDate.setDate(expiryDate.getDate() - 1);
    
      const now = new Date();
    
      const totalDays = Math.ceil(
        (expiryDate - purchaseDate) / (1000 * 60 * 60 * 24)
      );
    
      const remainingDays = Math.max(
        Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24)),
        0
      );
    
      const percentage = totalDays > 0
        ? (remainingDays / totalDays) * 100
        : 0;
    
      return {
        totalDays,
        remainingDays,
        percentage
      };
    };

    const getSubscriptionProgress = (
      purchaseDateStr,
      numberOfDays
    ) => {
      const purchaseDate = new Date(purchaseDateStr);
    
      // expiry = purchase date + number of days
      const expiryDate = new Date(purchaseDate);
      expiryDate.setDate(expiryDate.getDate() + numberOfDays);
    
      const now = new Date();
    
      const totalDays = Math.ceil(
        (expiryDate - purchaseDate) / (1000 * 60 * 60 * 24)
      );
    
      const remainingDays = Math.max(
        Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24)),
        0
      );
    
      const usedDays = Math.max(totalDays - remainingDays, 0);
    
      const percentage = totalDays > 0
        ? (remainingDays / totalDays) * 100
        : 0;
    
      const usedPercentage = totalDays > 0
        ? (usedDays / totalDays) * 100
        : 0;
    
      return {
        totalDays,
        usedDays,
        remainingDays,
        percentage, // remaining %
        usedPercentage, // used %
        expiryDate
      };
    };

    useEffect(() => {
      console.log('userprofile inkcustomerdata >>', inkcustomerdata);
      if(inkcustomerdata && Object.keys(inkcustomerdata)?.length > 0) {
        setfullname(inkcustomerdata?.fullname ? inkcustomerdata?.fullname : "");
        setemailaddress(inkcustomerdata?.emailaddress ? inkcustomerdata?.emailaddress : "");
        setphonenumber(inkcustomerdata?.mobilenumber ? inkcustomerdata?.mobilenumber : "");
        setcurrentcredits(inkcustomerdata?.credits ? inkcustomerdata?.credits : "");
        setcurrentplan(inkcustomerdata?.currentplan ? inkcustomerdata?.currentplan: "");
        setlastpurchased(inkcustomerdata?.lastpurchased ? inkcustomerdata?.lastpurchased : "");


        if(inkcustomerdata?.plantype == "fixed") {
          var currentcredits = parseInt(inkcustomerdata?.credits);
          var credits_used =  parseInt(inkcustomerdata?.credits_used);
          const remaining = currentcredits - credits_used;
          const percentage = (remaining / currentcredits) * 100;
          setremainingpercentage(percentage);

        } else if(inkcustomerdata?.plantype == "both") {
          var currentcredits = parseInt(inkcustomerdata?.credits);
          var credits_used =  parseInt(inkcustomerdata?.credits_used);
          const remaining = currentcredits - credits_used;
          const percentage = (remaining / currentcredits) * 100;
          setremainingpercentage(percentage);

        } else if(inkcustomerdata?.plantype == "daysvalidity") {
          // const { percentage, remainingDays } = getYearlyProgress(inkcustomerdata?.lastpurchased);
          const { percentage, remainingDays } = getSubscriptionProgress(inkcustomerdata?.lastpurchased);
          setremainingpercentage(percentage);
        } else {

        }

        fetchspendhostory();
        fetchallbilinghistory();



      } else {
        navigate('/login')
      }
    }, [])

    return (
      <div className="homepage-layout userprofilebg">
        {/* <ToastContainer
                position="top-right"
                toastClassName="custom-toast"
                bodyClassName="custom-toast-body"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                draggable
                theme="colored"
              /> */}
        <section>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="userprofileleftbg">
                  <div className="userplaceholderdiv">
                    <img src={userplaceholder} className="userplaceholderimg" />
                  </div>
                  <div className="userprofile-left-content-div">
                    <p className="userprofile-left-name">{inkcustomerdata?.fullname}</p>
                    <p className="userprofile-left-name userprofile-left-email">
                      {inkcustomerdata?.emailaddress}
                    </p>
                    <p className="userprofile-left-name userprofile-left-email">
                    {inkcustomerdata?.mobilenumber}
                    </p>
                    <p className="userprofile-left-name userprofile-left-email">
                      Member Since : {formatCreatedDateWithSuffix(inkcustomerdata?.created_at)}
                    </p>
                    {
                      inkcustomerdata && inkcustomerdata?.currentplan ?
                      <div className="user-creditsbg">
                      <div className="user-creditsbg-firstrow">
                        <FontAwesomeIcon
                          icon={faCoins}
                          className="userprofilecoins"
                          style={{
                            marginRight: 15,
                            cursor: "pointer",
                          }}
                        />
                        <div className="user-creditsbg-firstrow-rightdiv">
                          <p className="user-creditsbg-plantext">
                            Plan : {inkcustomerdata?.currentplan}
                          </p>
                          <p className="user-creditsbg-pendingtext">
                          {
                          inkcustomerdata?.plantype == "daysvalidity" ?
                            <span>{parseInt(inkcustomerdata?.credits_used)} Credits</span> :
                            <span>{parseInt(inkcustomerdata?.credits) - parseInt(inkcustomerdata?.credits_used)} Credits</span>
                          }
                          </p>
                          <p className="user-creditsbg-plantext">
                            of {inkcustomerdata?.credits} Credits
                          </p>
                          {/* {
                            inkcustomerdata?.currentplan == "Monthly Plan" ?
                            <p className="user-creditsbg-plantext">
                              {
                                getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) > 0 ?
                                getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) > 1 ?
                                 getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) + " days remaining"
                                 :
                                  getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) + " day remaining"


                                :
                                 <span style={{color: '#dc3545'}}>Expired</span>
                              }
                            </p> :
                            inkcustomerdata?.currentplan == "Annual Plan" ?
                            <p className="user-creditsbg-plantext">
                              {
                                getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) > 0 ?
                                getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) > 1 ?
                                 getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) + " days remaining"
                                 :
                                  getRemainingDays(inkcustomerdata?.lastpurchased, inkcustomerdata?.daysofplan) + " day remaining"
                                :
                                 <span style={{color: '#dc3545'}}>Expired</span>
                              }
                            </p> :
                            null
                          }  */}
                          <p className="user-creditsbg-plantext">
                              {
                                inkcustomerdata?.plantype && inkcustomerdata?.plantype !== "fixed" ?
                                getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) > 0 ?
                                getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) > 1 ?
                                 getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) + " days remaining"
                                 :
                                  getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) + " day remaining"


                                :
                                 <span style={{color: '#dc3545'}}>Expired</span>
                                 : null
                              }
                            </p>
                          
                        </div>
                      </div>
                      <div className="userprofile-progressbardiv">
                        <ProgressBar
                          completed={remainingpercentage}
                          label=""
                          height="12px"
                          customLabelStyles={{ display: "none" }}
                          bgColor="rgba(80, 67, 154, 1)"
                          baseBgColor="rgba(255,255,255,0.8)"
                        />
                        ;
                      </div>
                      <div className="userprofile-purchasebuttondiv">
                        <div className="registersubmitbtn" onClick={() => {navigate('/subscription-list')}}>
                          <p>Purchase More Credits</p>
                        </div>
                      </div>
                    </div> : 
                    <div className="" style={{padding: 15, marginTop: 15, paddingBottom: 5}}>
                      <div className="userprofile-purchasebuttondiv">
                        <div className="registersubmitbtn" onClick={() => {navigate('/subscription-list')}}>
                          <p>Purchase Credits</p>
                        </div>
                      </div>
                    </div>
                      
                    }
                    
                    <div className="userprofile-signout-btn" onClick={() => {handleuserlogout()}}>
                      <p>Sign Out</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="userprofilerightmaindiv">
                  <div className="userprofile-rhs-topbar">
                    <div
                      className={
                        activesection == "Updateprofile"
                          ? "userprofile-rhs-titlediv active"
                          : "userprofile-rhs-titlediv"
                      }
                      onClick={() => {
                        setactivesection("Updateprofile");
                      }}
                    >
                      <p>Update Profile</p>
                    </div>
                    <div
                      className={
                        activesection == "spendhistory"
                          ? "userprofile-rhs-titlediv active"
                          : "userprofile-rhs-titlediv"
                      }
                      onClick={() => {
                        setactivesection("spendhistory");
                      }}
                    >
                      <p>Spend History</p>
                    </div>
                    <div
                      className={
                        activesection == "subscription"
                          ? "userprofile-rhs-titlediv active"
                          : "userprofile-rhs-titlediv"
                      }
                      onClick={() => {
                        setactivesection("subscription");
                      }}
                    >
                      <p>Subscription & Billing</p>
                    </div>
                  </div>
                  <hr className="userprofile-rhs-topbar-border" />
                  <div className="userprofilerightmaincontentdiv">
                    {activesection == "Updateprofile" ? (
                      <div className="userprofile-rhs-updateprofile-div">
                        <div className="register-inputdiv">
                          <label>Full Name *</label>
                          <input
                            type="text"
                            value={fullname}
                            onChange={(t) => {
                              setfullname(t.target.value);
                            }}
                            className="register-textinput form-control"
                            placeholder="Enter your full name"
                          />
                          {fullnameerrormessage ? (
                            <p className="register-error-message">
                              {fullnameerrormessage}
                            </p>
                          ) : null}
                        </div>
                        <div className="register-inputdiv">
                          <label>Email Address *</label>
                          <input
                            type="text"
                            value={emailaddress}
                            onChange={(t) => {
                              setemailaddress(t.target.value);
                            }}
                            disabled
                            className="register-textinput form-control"
                            placeholder="Enter your email address"
                          />
                          {emailaddresserrormessage ? (
                            <p className="register-error-message">
                              {emailaddresserrormessage}
                            </p>
                          ) : null}
                        </div>
                        <div className="register-inputdiv">
                          <label>Mobile Number *</label>
                          {/* <input
                    type="text"
                    value={phonenumber}
                    onChange={(t) => {
                      setphonenumber(t.target.value);
                    }}
                    className="register-textinput form-control"
                    placeholder="Enter your contact number"
                  /> */}
                          <PhoneInput
                            defaultCountry="in"
                            name="mobile"
                            value={phonenumber}
                            onChange={(e) => {
                              // setFormData({ ...formData, mobile: e });
                              setphonenumber(e);
                            }}
                            style={{ marginBottom: 15 }}
                          />
                          {phonenumbererrormessage ? (
                            <p className="register-error-message phonenumbererrormessage">
                              {phonenumbererrormessage}
                            </p>
                          ) : null}
                        </div>
                        <div className="register-inputdiv">
                          <label>Password *</label>
                          <input
                            type="password"
                            value={password}
                            onChange={(t) => {
                              setpassword(t.target.value);
                            }}
                            className="register-textinput form-control"
                            placeholder="Enter your password"
                          />
                          {passworderrormessage ? (
                            <p className="register-error-message">
                              {passworderrormessage}
                            </p>
                          ) : null}
                        </div>
                        <div className="register-inputdiv">
                          <label>Re-type Password *</label>
                          <input
                            type="password"
                            value={repassword}
                            onChange={(t) => {
                              setrepassword(t.target.value);
                            }}
                            className="register-textinput form-control"
                            placeholder="Re-enter your password"
                          />
                          {repassworderrormessage ? (
                            <p className="register-error-message">
                              {repassworderrormessage}
                            </p>
                          ) : null}
                        </div>
                        {mismatchpassworderrormessage ? (
                          <p className="register-error-message">
                            {mismatchpassworderrormessage}
                          </p>
                        ) : null}
                        <div
                          className="registersubmitbtn"
                          onClick={() => {
                            if (showloading) {
                            } else {
                              handlesignupfunc();
                            }
                          }}
                        >
                          {showloading ? (
                            <div className="spinnermaindiv">
                              <Spinner
                                color="#fff"
                                size={16}
                                className="spinnerCenter"
                              />
                            </div>
                          ) : (
                            <p>Update Profile</p>
                          )}
                        </div>
                      </div>
                    ) : activesection == "spendhistory" ? (
                      <div className="spendhistorytablediv">
                        {
                          spendhistorydata?.length > 0 ?
                          <table class="table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Slides converted</th>
                              <th>Credits Used</th>
                              <th>Link</th>
                              <th>Remaining</th>
                              <th>Plan</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              spendhistorydata?.map((item, index) => {
                                return (
                                  <tr>
                                    <td>
                                      {formatCreatedDateWithSuffix(
                                        item?.created_at
                                      )}
                                    </td>
                                    <td>{item?.slides_converted}</td>
                                    <td className="creditsusedcolor">
                                      -{item?.credits_used}
                                    </td>
                                    <td>
                                      {
                                        item?.downloadlink ?
                                        <Link to={item?.downloadlink} className="" target="_blank">
                                        <FontAwesomeIcon
                                          icon={faDownload}
                                          className="userprofilecoins"
                                          style={{
                                            fontSize: 18,
                                            marginRight: 15,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Link> :
                                      null
                                      }
                                      
                                    </td>
                                    <td>{item?.remaining}</td>
                                    <td>{item?.plan}</td>
                                  </tr>
                                );
                              })
                            }
                          </tbody>
                        </table> : 
                        <p className="data-not-available">Data not available</p>
                        }
                        
                      </div>
                    ) : (
                      <div className="spendhistorytablediv">
                        {
                          bilingdata?.length > 0 ?
                          <table class="table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Plan</th>
                              <th>Slides</th>
                              <th>Amount Paid</th>
                              <th>Promo Code</th>
                              <th>Payment ID</th>
                              {/* <th>Status</th> */}
                              
                            </tr>
                          </thead>
                          <tbody>
                            {
                              bilingdata?.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{formatCreatedDateWithSuffix(item?.created_at)}</td>
                                    <td>{item?.plan}</td>
                                    <td>{item?.plantype == "daysvalidity" ? "Unlimited" : parseInt(item?.slides) + parseInt(item?.additional_slides)}</td>
                                    <td>{item?.currency} {item?.total}</td>
                                    <td>{item?.promocode ? item?.promocode : "--"}</td>
                                    <td>{item?.paymentid}</td>
                                      
                                      
                                    
                                  </tr>
                                );
                              })

                            }
                            
                            {/* <tr>
                              <td>10 March 2026</td>
                              <td>Monthly</td>
                              <td>$ 10</td>
                              <td className="creditsusedcolor">Expired</td>
                              
                            </tr> */}
                          </tbody>
                        </table> :
                        <p className="data-not-available">Data not available</p>
                        }
                        
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
}

export default UserProfile